module.exports = __webpack_public_path__ + "498f69bb8e97c276508d08b38bacac06.svg";